



































































































import Vue from "vue";
import Component from "vue-class-component";
import { Ref, Prop, Emit } from "vue-property-decorator";
import {
  MedicalSpecification,
  DetailModel,
  JobDiv
} from "@/components/medicalTransmissionEdit/types";
import NumberInput from "@/components/common/NumberInput.vue";
import DetailEditDialog from "@/components/medicalTransmissionEdit/DetailEditDialog.vue";
import { SelectItemString } from "@/types";

@Component({
  components: { NumberInput, DetailEditDialog }
})
export default class Detail extends Vue {
  @Prop() details!: DetailModel[];
  @Prop() expense_type!: number;
  @Prop() burden_category_codes!: SelectItemString[]; //負担区分コード（画面用）
  @Prop() occupation_codes!: SelectItemString[]; //職種等コード
  @Prop() visit_frequency_codes!: SelectItemString[]; //訪問看護回数コード
  @Prop() instruction_classification_codes!: SelectItemString[]; //指示区分コード
  @Ref("editDialog") private readonly editDialog!: DetailEditDialog; //明細編集ダイアログ

  @Emit("change")
  public change() {
    return;
  }

  private editMode = false; //編集モード

  //編集モードON
  private editOn() {
    this.editMode = true;
  }
  //編集モードOFF
  private editOff() {
    this.editMode = false;
  }

  //明細行追加
  private open() {
    this.editDialog.open();
  }

  //明細行編集
  private openUpdate(detail: DetailModel) {
    this.editDialog.openUpdate(detail);
  }

  //保存
  private updateDetail(editDetail: DetailModel) {
    if (editDetail.idx == -1) {
      //追加
      editDetail.idx = this.details.length;
      this.details.push(editDetail);
    } else {
      //更新
      let count = -1;
      for (const d of this.details) {
        count++;
        if (d.idx == editDetail.idx) {
          break;
        }
      }
      this.details.splice(count, 1, editDetail);
    }
    this.change();
  }

  //削除
  private deleteDetail(editDetail: DetailModel) {
    let count = -1;
    for (const d of this.details) {
      count++;
      if (d.idx == editDetail.idx) {
        break;
      }
    }
    this.details.splice(count, 1);
    //インデックスのリセット
    let idx = 0;
    for (const d of this.details) {
      d.idx = idx;
      idx++;
    }
    this.change();
  }

  //複数選択の表示
  private dispCodes(select_codes: string[], codes: SelectItemString[]): string {
    let disp = "";
    for (const c of codes) {
      for (const sc of select_codes) {
        if (sc == c.value) {
          disp += c.disp + ", ";
        }
      }
    }
    return disp.slice(0, -2);
  }

  private dispJobDivs(
    select_codes: JobDiv[],
    codes: SelectItemString[]
  ): string {
    let disp = "";
    for (const c of codes) {
      for (const sc of select_codes) {
        if (sc.job_div == c.value) {
          disp += c.disp + ", ";
        }
      }
    }
    return disp.slice(0, -2);
  }

  //特別地域の表示
  private dispIsSpecialArea(isSpecialArea: number): string {
    if (isSpecialArea == 1) {
      return "○";
    }
    return "";
  }
}
